<template>
  <a class="button" :href="href" target="_blank">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "Button",

  props: {
    href: {
      default: null,
      type: String
    }
  }
};
</script>

<style scoped lang="scss">
.button {
  padding: 15px 60px;
  border-radius: 3px;
  background-color: #fff;
  color: #000;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  transition: 180ms;

  &:hover {
    background-color: #910a2d;
    color: #fff;
  }
}
</style>
